import { get } from '@/services/index.js';

function parseFacilityCategories(categories) {
  return categories
    .filter((category) => category.facility && category.facility.length > 0)
    .sort((first, second) => first.position - second.position)
    .map((category) => ({
      // the "Uncategorized" bucket carries a null id, so its name keys the section
      id: category.id || category.name,
      name: category.name,
      facility: category.facility
        .slice()
        .sort((first, second) => first.category_position - second.category_position),
    }));
}

// merchants whose grouped endpoint fails or is not filled in yet keep the flat
// list the merchant payload already carries, shown as one unheaded section
function buildLegacyFacilityCategories(merchant) {
  const legacyFacilities = merchant.facilities || [];
  if (legacyFacilities.length == 0) return [];
  return [{ id: 'legacy', name: '', facility: legacyFacilities }];
}

/**
 * Loads the merchant's facilities grouped by category, sorted by position.
 * @param {Object} merchant the active merchant (needs id, facilities)
 * @returns {Promise<Array<{id: (number|string), name: string, facility: Array}>>}
 */
export async function fetchMerchantFacilityCategories(merchant) {
  try {
    const apiResponse = await get('CORE_HOTEL', 'v2/merchant-facility', {
      merchant_id: merchant.id,
    });
    const { success, message, data = [] } = apiResponse.data;
    if (!success) throw new Error(message);

    const categories = parseFacilityCategories(data);
    if (categories.length > 0) return categories;
  } catch (error) {
    console.log('ERROR fetchMerchantFacilityCategories :', error.message || error);
  }
  return buildLegacyFacilityCategories(merchant);
}

/**
 * @param {Array<{facility: Array}>} categories grouped facilities
 * @returns {Array} every facility, in category order
 */
export function flattenFacilityCategories(categories) {
  return categories.reduce((all, category) => all.concat(category.facility), []);
}



// WEBPACK FOOTER //
// ./src/utils/merchantFacility.js